import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate } from "react-router";
import { signUpSchema } from "../auth/Schema";
import ErrorMessage from "../components/ErrorMessage";
import Eye from "../components/Eye";
import { pageRoutes } from "../routes/PageRoutes";
import {
    getAllSubscriptionPlan,
    userSignUp,
} from "../redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../components/Loader";
import SelectSubscription from "../components/SelectSubscription";
import CardDeatilsModel from "../components/CardDeatilsModel";
import { message } from "antd";
import PhoneInput from 'react-phone-number-input'
import { isValidPhoneNumber } from 'react-phone-number-input'
import "react-phone-number-input/style.css";
import WaterRipple from "../layout/RippleEffect";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUB_KEY
).catch(() => null);

const SignUp = () => {
    const stripe = useStripe();
    const { isLoading, subscriptionPlane } = useSelector(
        (state) => state?.authReducer
    );

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isEye, setIsEye] = useState(false);
    const [isEye1, setIsEye1] = useState(false);

    const [isSubscription, setIsSubscription] = useState(false);
    const [isCard, setIsCart] = useState(false);

    const [subscriptionType, setSubscriptionType] = useState();
    const [signUpValues, setSignUpValues] = useState();

    const initialState = {
        first_name: "",
        last_name: "",
        company_name: "",
        email: "",
        phone_no: "",
        password: "",
        confirm_password: "",
        agreeTerms: false,
        agreePrivacy: false,
        agreeAcceptableUse: false,
    };

    useEffect(() => {
        dispatch(getAllSubscriptionPlan());
    }, []);

    const handleSignUp = async (values, { setSubmitting }) => {
        setSubmitting(false);
        setIsSubscription(true);
        setIsCart(false);
        setSignUpValues(values);
    };

    const onSelectSubscription = (value) => {
        setIsCart(true);
        setIsSubscription(false);
        setSubscriptionType(value);
    };

    const handleClickBack = () => {
        setIsSubscription(true);
        setIsCart(false);
    };

    const handleCancel = () => {
        setIsSubscription(false);
        setIsCart(false);
        setSubscriptionType();
    };

    const handleCartDetailsAdd = (val, err) => {
        if (err?.message) {
            message.error(err?.message);
        } else {
            const callback = async (response) => {
                if (response?.success) {
                    setIsSubscription(false);
                    setIsCart(false);
                    setSignUpValues();
                    setSubscriptionType();
                    message.success("Registration successful!");
                    navigate(pageRoutes?.login);
                } else if (response?.actionRequired && response?.clientSecret) {
                    if (!stripe) {
                        message.error("Stripe payment form is not ready. Please try again.");
                        return;
                    }
                    try {
                        message.info("Confirming your payment authentication...");
                        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
                            response.clientSecret,
                            { payment_method: val?.id }
                        );

                        if (confirmError) {
                            message.error(confirmError.message || "Payment authentication failed.");
                        } else if (paymentIntent && (paymentIntent.status === "succeeded" || paymentIntent.status === "processing")) {
                            message.success("Payment authenticated and registration successful!");
                            setIsSubscription(false);
                            setIsCart(false);
                            setSignUpValues();
                            setSubscriptionType();
                            navigate(pageRoutes?.login);
                        } else {
                            message.error("Payment confirmation failed.");
                        }
                    } catch (confirmErr) {
                        console.error("Stripe confirm error:", confirmErr);
                        message.error("An error occurred during Stripe 3D Secure verification.");
                    }
                }
            };
            const data = {
                first_name: signUpValues?.first_name.trim(),
                last_name: signUpValues?.last_name?.trim(),
                company_name: signUpValues?.company_name.trim(),
                email: signUpValues?.email?.trim(),
                phone_no: signUpValues?.phone_no,
                password: signUpValues?.password,
                planId: subscriptionType?.id || "",
                paymentMethodId: val?.id,
            };
            dispatch(userSignUp({ payload: data, callback }));
        }
    };

    if (isLoading) {
        return <Loader />;
    }
    return (
        <section className="et_signup_main_bg">
            <div className="ct_header_flex">
                <div className="et_logo">
                  <a href="javascript:void(0)"  onClick={() => {
                                  navigate(pageRoutes?.landingpage);
                                }}>  <img src="img/Logo_blue_new.png" /></a>
                </div>
            </div>






            {/* signup content */}
            <div className="auth-wrapper">
                <WaterRipple />
                <div className="container-fluid">

                    <div className="ct-login-wrapper">
                        <div className="ct-login-card ct_custom_scroll">
                            <div className="text-center ct_mb_32">
                                <div className="ct-title ct_fs_24 ct_idlewild_bold mb-2 ct_blue_text ct_fs_20_575">
                                    WELCOME ABOARD
                                </div>
                                <div className="ct-subtitle ct_blue_text ct_ff_ProximaNova_regular mb-0 ct_fs_14 ct_fw_400">
                                    Join FirstMate ServiceHub and start managing your services smarter
                                    and faster.
                                </div>
                            </div>



                            <Formik
                                initialValues={initialState}
                                validationSchema={signUpSchema}
                                onSubmit={(values, actions) => {
                                    handleSignUp(values, actions);
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    setFieldError,
                                    setFieldValue,
                                }) => (
                                    <form className="">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        First Name{" "}
                                                        <span className="ct_required_star">*</span>
                                                    </label>
                                                    <input
                                                        id="first_name"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values?.first_name}
                                                        type="text"
                                                        class="form-control ct_input ct_border_radius_8"
                                                        required
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="first_name"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        Last Name{" "}
                                                        <span className="ct_required_star">*</span>
                                                    </label>
                                                    <input
                                                        id="last_name"
                                                        value={values?.last_name}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        type="text"
                                                        class="form-control ct_input ct_border_radius_8"
                                                        required
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="last_name"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-12">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        Company Name{" "}
                                                        <span className="ct_required_star">*</span>
                                                    </label>
                                                    <input
                                                        id="company_name"
                                                        value={values?.company_name}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        type="text"
                                                        class="form-control ct_input ct_border_radius_8"
                                                        required
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="company_name"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        {" "}
                                                        Email <span className="ct_required_star">*</span>
                                                    </label>
                                                    <input
                                                        id="email"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values?.email}
                                                        type="email"
                                                        class="form-control ct_input ct_border_radius_8"
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="email"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        Phone <span className="ct_required_star">*</span>
                                                    </label>

                                                    <PhoneInput
                                                        id="phone_no"
                                                        className="form-control bg-transparent ct_phone_bg_transparent"
                                                        defaultCountry="AU"
                                                        value={values?.phone_no}
                                                        onChange={(val) => {
                                                            const safeVal = val ?? '';
                                                            if (
                                                                typeof safeVal === 'string' &&
                                                                safeVal.length > 2 &&
                                                                isValidPhoneNumber(safeVal)
                                                            ) {
                                                                setFieldValue('phone_no', safeVal);
                                                            } else if (!isValidPhoneNumber(safeVal)) {
                                                                setFieldError('phone_no', 'Please enter valid phone number');
                                                                setFieldValue('phone_no', safeVal);
                                                            }
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="phone_no"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        Password{" "}
                                                        <span className="ct_required_star">*</span>
                                                    </label>
                                                    <div className=" position-relative">
                                                        <input
                                                            id="password"
                                                            value={values?.password}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            type={isEye ? "text" : "password"}
                                                            class="form-control ct_input ct_border_radius_8 ct_input_pe_40"
                                                        />
                                                        <Eye
                                                            isEye={isEye}
                                                            onClick={() => setIsEye(!isEye)}
                                                        />
                                                    </div>
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="password"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div class="mb-3">
                                                    <label className="mb-2 ct_fw_700">
                                                        Confirm Password{" "}
                                                        <span className="ct_required_star">*</span>
                                                    </label>
                                                    <div className=" position-relative">
                                                        <input
                                                            id="confirm_password"
                                                            value={values?.confirm_password}
                                                            onBlur={handleBlur}
                                                            onChange={handleChange}
                                                            type={isEye1 ? "text" : "password"}
                                                            class="form-control ct_input ct_border_radius_8 ct_input_pe_40"
                                                            required
                                                        />
                                                        <Eye
                                                            isEye={isEye1}
                                                            onClick={() => setIsEye1(!isEye1)}
                                                        />
                                                    </div>
                                                    <ErrorMessage
                                                        errors={errors}
                                                        touched={touched}
                                                        fieldName="confirm_password"
                                                    />
                                                </div>
                                            </div>


                                        </div>



                                        <div className="ct_mt_20 d-flex flex-column gap-3 align-items-start">
                                            {/* Policy 1: Terms & Conditions */}
                                            <div className="ct_checkbox_main align-items-start">
                                                <div>
                                                    <input
                                                        id="agreeTerms"
                                                        name="agreeTerms"
                                                        checked={values?.agreeTerms}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        type="checkbox"
                                                        className="ct_hidden-xs-up"
                                                    />
                                                    <label
                                                        htmlFor="agreeTerms"
                                                        className="ct_checkbox_cbx et_checkbox_clr"
                                                    ></label>
                                                </div>
                                                <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                                                    I have read and agree to the{" "}
                                                    <a
                                                        href="/terms-and-conditions"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="ct_blue_text ct_fw_600 text-decoration-underline"
                                                    >
                                                        Terms & Conditions
                                                    </a>
                                                </p>
                                            </div>
                                            {touched?.agreeTerms && errors?.agreeTerms && (
                                                <span className="d-block animate__animated animate__fadeIn" style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                    {errors?.agreeTerms}
                                                </span>
                                            )}

                                            {/* Policy 2: Privacy Policy */}
                                            <div className="ct_checkbox_main align-items-start">
                                                <div>
                                                    <input
                                                        id="agreePrivacy"
                                                        name="agreePrivacy"
                                                        checked={values?.agreePrivacy}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        type="checkbox"
                                                        className="ct_hidden-xs-up"
                                                    />
                                                    <label
                                                        htmlFor="agreePrivacy"
                                                        className="ct_checkbox_cbx et_checkbox_clr"
                                                    ></label>
                                                </div>
                                                <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                                                    I have read and agree to the{" "}
                                                    <a
                                                        href="/privacy-policy"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="ct_blue_text ct_fw_600 text-decoration-underline"
                                                    >
                                                        Privacy Policy
                                                    </a>
                                                </p>
                                            </div>
                                            {touched?.agreePrivacy && errors?.agreePrivacy && (
                                                <span className="d-block animate__animated animate__fadeIn" style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                    {errors?.agreePrivacy}
                                                </span>
                                            )}

                                            {/* Policy 3: Acceptable Use Policy */}
                                            <div className="ct_checkbox_main align-items-start">
                                                <div>
                                                    <input
                                                        id="agreeAcceptableUse"
                                                        name="agreeAcceptableUse"
                                                        checked={values?.agreeAcceptableUse}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        type="checkbox"
                                                        className="ct_hidden-xs-up"
                                                    />
                                                    <label
                                                        htmlFor="agreeAcceptableUse"
                                                        className="ct_checkbox_cbx et_checkbox_clr"
                                                    ></label>
                                                </div>
                                                <p className="mb-0 ct_fs_14 ct_fw_400 ct_text_dark">
                                                    I have read and agree to the{" "}
                                                    <a
                                                        href="/acceptable-use-policy"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="ct_blue_text ct_fw_600 text-decoration-underline"
                                                    >
                                                        Acceptable Use Policy
                                                    </a>
                                                </p>
                                            </div>
                                            {touched?.agreeAcceptableUse && errors?.agreeAcceptableUse && (
                                                <span className="d-block animate__animated animate__fadeIn" style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                                                    {errors?.agreeAcceptableUse}
                                                </span>
                                            )}
                                        </div>

                                        <div className="mt-4">
                                            <button
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="ct_orange_btn w-100"
                                                disabled={!values?.agreeTerms || !values?.agreePrivacy || !values?.agreeAcceptableUse}
                                                style={{
                                                    opacity: (!values?.agreeTerms || !values?.agreePrivacy || !values?.agreeAcceptableUse) ? 0.6 : 1,
                                                    cursor: (!values?.agreeTerms || !values?.agreePrivacy || !values?.agreeAcceptableUse) ? "not-allowed" : "pointer"
                                                }}
                                            >
                                                Sign up
                                            </button>
                                        </div>




                                        <div class="ct_login_divider mt-3"></div>

                                        <div class="ct_mt_25 text-center ct_text_dark ct_fs_14 ct-fw_400">
                                            Already have an account?
                                            <a onClick={() => navigate(pageRoutes.login)}
                                                href="javascript:void(0)" class="ct_blue_text ct_fs_14 ct_fw_600 ms-2">
                                                Log In
                                            </a>
                                        </div>





                                    </form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>

            </div>




            {/* signup content end */}





            {isSubscription && !isCard &&
                <SelectSubscription
                    onClick={onSelectSubscription}
                    handleCancel={handleCancel}
                    subscriptionType={subscriptionType}
                    subscriptionPlane={subscriptionPlane}
                />
            }
            {isCard && !isSubscription &&
                <CardDeatilsModel
                    onCancel={handleClickBack}
                    onClick={handleCartDetailsAdd}
                />
            }
        </section>
    );
};

export default () => (
    <Elements stripe={stripePromise}>
        <SignUp />
    </Elements>
);